<template>
  <div class="cart-confirmation">
    <div class="cart-confirmation-container" :class="{'is-loading': !user || !cart }">
      <div v-if="user && cart">
        <p class="cart-confirmation-title">{{ Translator('front.cart.confirmation.title', {'name': `${user.firstName} ${user.lastName}`}) }}</p>
        <p class="cart-confirmation-subtitle">{{ Translator('front.cart.confirmation.subtitle') }}</p>
        <p class="cart-confirmation-order">{{ Translator('front.cart.confirmation.order', {'number': cart.number}) }}</p>
        <p class="cart-confirmation-date">{{ today }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import OrdersService from '@/services/Orders';
import UsersService from '@/services/Users';
import moment from 'moment';

export default {
  name: 'cart-confirmation',
  data () {
    return {
      cart: OrdersService.cart,
      user: UsersService.user,
      today: moment().format('DD MMM YYYY')
    }
  },
  created() {
    this._onUpdateCart = this._onUpdateCart.bind(this);
    this._onUpdateUser = this._onUpdateUser.bind(this);
  },
  beforeDestroy() {
    OrdersService.off('updated', this._onUpdateCart);
    UsersService.off('updated', this._onUpdateUser);
  },
  mounted() {
    OrdersService.on('updated', this._onUpdateCart);
    UsersService.on('updated', this._onUpdateUser);
    const event = new CustomEvent('cart:update', { detail: 0 });
    document.body.dispatchEvent(event);
  },
  methods: {
    _onUpdateCart(res) {
      this.cart = res;
    },
    _onUpdateUser(res) {
      this.user = res;
    },

    Routing(key, datas = null) {
      return window.Routing.generate(key, datas);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">

  .cart-confirmation {
    margin-right: 0;
    margin-left: auto;
    padding: rem(20);
    width: 100%;
    margin-bottom: rem(30);
    @include tablet {
      padding: rem(40);
      width: 40%;
    }
    @include desktop {
      width: 30%;
    }
    @include desktop-xl {
      width: 25%;
    }
    @include desktop-xxl {
      width: 20%;
    }
  }
  .cart-confirmation-title,
  .cart-confirmation-subtitle {
    margin-bottom: rem(20);
  }
  .cart-confirmation-title,
  .cart-confirmation-subtitle,
  .cart-confirmation-date,
  .cart-confirmation-order {
    @include upper;
  }
</style>
